import { useState } from 'react';

function useMySelection<T, S extends T = T>(getId: (item: T) => number | string) {
  const [collection, setCollection] = useState<T[]>([]);

  const addRows = (row: S[]) => {
    setCollection((prevState) => [...prevState, ...row]);
  };

  const removeRows = (rowId: (string | number)[]) => {
    setCollection((prevState) => {
      return prevState.filter((item) => !rowId.includes(getId(item)));
    });
  };

  const reset = () => {
    setCollection([]);
  };

  return {
    collection,
    addRows,
    removeRows,
    reset,
  };
}

export default useMySelection;
